import {
  useAxiosGet,
  useAxiosPost,
  useAxiosPut,
  useAxiosPatch,
  useAxiosDelete,
} from '@/hooks/useAxios';

export const getSubOrganizationsApi = () => {
  const [callApi, { isLoading, isError, isSuccess }] = useAxiosGet();
  const getSubOrganizations = async () => {
    const response = await callApi('organisation/get-sub-organisations');
    return response.data;
  };
  return { getSubOrganizations, isError, isLoading, isSuccess };
};

export const generateInvitationLinkApi = () => {
  const [callApi, { isLoading, isError, isSuccess }] = useAxiosPost();

  const generateInvitationLink = async (data: object) => {
    const response = await callApi('organisation/invite-code', data);
    return response.data;
  };
  return { generateInvitationLink, isError, isLoading, isSuccess };
};

export const updateOrganisationDataApi = () => {
  const [callApi, { isLoading, isError, isSuccess }] = useAxiosPut();

  const updateOrganisationData = async (id: string, data: object) => {
    const response = await callApi(`organisation/${id}`, data);
    return response;
  };
  return { updateOrganisationData, isError, isLoading, isSuccess };
};

export const createPartnerApi = () => {
  const [callApi, { isLoading, isError, isSuccess }] = useAxiosPost();

  const createPartner = async (data: object) => {
    const response = await callApi('organisation/internal/partner', data);
    return response.data;
  };
  return { createPartner, isError, isLoading, isSuccess };
};

export const updatePartnerStatusApi = () => {
  const [callApi, { isLoading, isError, isSuccess }] = useAxiosPut();

  const updatePartnerStatus = async (id: string, data: object) => {
    const response = await callApi(`organisation/internal/partner/${id}`, data);
    return response;
  };
  return { updatePartnerStatus, isError, isLoading, isSuccess };
};

export const updatePartnerApi = () => {
  const [callApi, { isLoading, isError, isSuccess }] = useAxiosPatch();

  const updatePartner = async (id: string, data: object) => {
    const response = await callApi(`organisation/internal/partner/${id}`, data);
    return response;
  };
  return { updatePartner, isError, isLoading, isSuccess };
};

export const deletePartnerApi = () => {
  const [callApi, { isLoading, isError, isSuccess }] = useAxiosDelete();

  const deletePartner = async (id: string) => {
    const response = await callApi(`organisation/internal/partner/${id}`);
    return response;
  };
  return { deletePartner, isError, isLoading, isSuccess };
};
